import { render, staticRenderFns } from "./PrintMaengel.vue?vue&type=template&id=0af5b4c4&scoped=true"
import script from "./PrintMaengel.vue?vue&type=script&lang=js"
export * from "./PrintMaengel.vue?vue&type=script&lang=js"
import style0 from "./PrintMaengel.vue?vue&type=style&index=0&id=0af5b4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5b4c4",
  null
  
)

export default component.exports